/* eslint-disable */
// Here eslint disable is use to avoid line width error
import React from "react";

const Chat = (props: { className?: string }) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
    <path d="M0,0H19.848V19.848H0Z" fill="none" />
    <path
      d="M8.616,3h3.308a6.616,6.616,0,1,1,0,13.232v2.894C7.789,17.472,2,14.991,2,9.616A6.616,6.616,0,0,1,8.616,3ZM10.27,14.578h1.654a4.962,4.962,0,1,0,0-9.924H8.616A4.962,4.962,0,0,0,3.654,9.616c0,2.985,2.036,4.934,6.616,7.013Z"
      transform="translate(-0.346 -0.519)"
      fill="currentColor"
    />
  </svg>
);

export { Chat };
